export const config = {
  env: process.env.NODE_ENV,
  publicURL: process.env.PUBLIC_URL || '',
  apiURL: process.env.REACT_APP_API_URL || '',
  buildFolder: process.env.REACT_APP_BUILD_FOLDER || '/Build'
}
